module.exports = __webpack_public_path__ + "static/img/clause_confirmation112.2c19fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_confirmation112.png
// module id = g7a9
// module chunks = 1